export type SyncState = "idle" | "syncing" | "error";

type SyncListener = (state: SyncState, detail?: { pendingCount?: number; failedCount?: number }) => void;

let state: SyncState = "idle";
const listeners = new Set<SyncListener>();

export function getSyncState(): SyncState {
  return state;
}

export function setSyncState(next: SyncState, detail?: { pendingCount?: number; failedCount?: number }): void {
  state = next;
  listeners.forEach((l) => l(next, detail));
}

export function subscribeSyncState(listener: SyncListener): () => void {
  listeners.add(listener);
  listener(state);
  return () => listeners.delete(listener);
}

export const OUTBOX_QUEUED_EVENT = "mivo:outbox-queued";

export function emitOutboxQueued(outboxId: string): void {
  window.dispatchEvent(new CustomEvent(OUTBOX_QUEUED_EVENT, { detail: { outboxId } }));
}
